"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HermeticOrderOfMars = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const RedTourismWave_1 = require("../turmoil/RedTourismWave");
const Size_1 = require("../render/Size");
class HermeticOrderOfMars extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.HERMETIC_ORDER_OF_MARS,
            cost: 10,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oxygen(4).max()),
            metadata: {
                cardNumber: 'X56',
                description: 'Oxygen must be 4% or less. Increase your M€ production 2 steps. Gain 1 M€ per empty area adjacent to your tiles.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(2));
                    b.megacredits(1).slash().emptyTile('normal', Size_1.Size.SMALL).asterix();
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        const amount = RedTourismWave_1.RedTourismWave.getAdjacentEmptySpacesCount(player);
        player.addResource(Resources_1.Resources.MEGACREDITS, amount);
        return undefined;
    }
}
exports.HermeticOrderOfMars = HermeticOrderOfMars;
//# sourceMappingURL=HermeticOrderOfMars.js.map